import React from 'react'

const ButtonBlackReturn = ({ title, onClick }) => {
    return (
        <div className='d-flex align-items-center'>
            <i
                type='button'
                onClick={onClick}
                className="fa-solid fa-arrow-left d-block fs-3"
            >
            </i>
            <h5 className='ps-2 m-0 custom-h4'>
                {title}
            </h5>
        </div>

    )
}

export default ButtonBlackReturn